<template>
  <div class="bf-layout">
    <div class="bf-layout__header">
      <slot name="header" />
    </div>

    <div class="bf-layout__content">
      <slot />
    </div>

    <div class="bf-layout__modules">
      <div class="bf-layout__logo"></div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.bf-layout {
  display: flex;
  flex-direction: column;
  height: 100%;

  &__header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    background-color: var(--color-light);
    gap: 1.6rem;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid var(--color-dark-10);
    z-index: 100;
  }

  &__content {
    flex-grow: 1;
    padding-top: 6rem;
    overflow-y: auto;
    scrollbar-gutter: stable;
  }

  &__logo {
    background-image: url(@/assets/logo-white.svg);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 19.2rem;
    height: 2.8rem;
  }

  &__modules {
    color: var(--color-light);
    background-color: var(--color-dark);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.6rem;
    font-family: 'Roboto Condensed', sans-serif;
  }
}
</style>
